<template>
  <input v-model="ans" />
</template>

<script>
export default {
  props: ["k"],
  data() {
    return {
      ans: "",
    };
  },
  watch: {
    ans() {
      this.$store.state[`${this.k}_ans`] = this.ans;
    },
  },
};
</script>


<style lang="scss" scoped>
</style>